import { createAsyncThunk } from "@reduxjs/toolkit";

const GetAuditLogs = createAsyncThunk(
    "audit-logs/GetAuditLogs",
    async () => {
        try {
            // const data = await auditlogs.getAllAuditLogs()
            // return data;
        } catch (err) {
            console.log("error");
        }
    }
);

export { GetAuditLogs };